export default {
  tablet: '(max-width: 900px)',
  mobile: '(max-width: 640px)'
}
